import { NewPaymentMethodDelegate } from 'billing/payment-methods/PaymentMethodsRootViewModel'
import Team from 'iam/models/Team'
import TeamPaymentsViewModel from 'iam/screens/Teams/Team/TeamPayments/TeamPaymentsViewModel'
import TabController, { TabSpec } from 'infra/TabController'
import TeamDetailsViewModel from './TeamDetails/TeamDetailsViewModel'
import TeamStore from 'iam/TeamStore'
import { GetCurrentMember } from 'iam/SessionStore'
import { task } from 'mobx-task'
import { Id } from 'types/definitions'
import { observable, computed, makeObservable } from 'mobx'
import TeamMembersViewModel from './TeamMembers/TeamMembersViewModel'
import TeamRoleStore from 'iam/TeamRoleStore'
import TeamMemberStore from 'iam/TeamMemberStore'
import InvitationStore from 'iam/InvitationStore'
import BillingStore from 'billing/BillingStore'
import { AlertFactory } from 'alerts/Alert'

export default class TeamViewModel {
  @observable tabs = new TabController<Tab>(() => [
    this.teamMembersVM.canManageTeamMember && TabSpec(Tab.Members, 'Members'),
    ...(this.shouldShowBilling && this.teamPaymentsVM.canManageTeamBilling
      ? [TabSpec(Tab.PaymentMethods, 'Payment Methods')]
      : []),
    TabSpec(
      Tab.Details,
      'Details',
      () => !this.teamDetailsVM.validation.isValid,
    ),
  ])

  teamDetailsVM = new TeamDetailsViewModel(
    this.team,
    this.teamStore,
    this.getCurrentMember,
    this.newAlert,
  )

  teamMembersVM = new TeamMembersViewModel(
    this.team,
    this.teamRoleStore,
    this.teamMembersStore,
    this.invitationStore,
    this.getCurrentMember,
    this.newAlert,
  )

  teamPaymentsVM = new TeamPaymentsViewModel(
    this.getCurrentMember,
    this.team,
    this.billingStore,
    this.newPaymentMethod,
  )

  constructor(
    public team: Team,
    public teamStore: TeamStore,
    private getCurrentMember: GetCurrentMember,
    private teamRoleStore: TeamRoleStore,
    private teamMembersStore: TeamMemberStore,
    private invitationStore: InvitationStore,
    private billingStore: BillingStore,
    private newPaymentMethod: NewPaymentMethodDelegate,
    private newAlert: AlertFactory,
  ) {
    makeObservable(this)
  }

  activate = task(async () => {
    await Promise.all([
      this.teamDetailsVM.activate(),
      this.teamMembersVM.activate(),
      this.teamPaymentsVM.activate(),
    ])
  })

  @computed
  get currentTeam() {
    return this.team
  }

  @computed
  get shouldShowBilling() {
    return this.billingStore.billingEnabledForCurrentWorkspace
  }

  deactivate() {
    //
  }

  uploadPicture = task.resolved(async (file) => {
    return this.teamStore.changeAvatar(Id.assert(this.team.id), file)
  })
}

/**
 * View Tab
 */
export const enum Tab {
  Details,
  PaymentMethods,
  Members,
}
